import React from 'react';
import styles from "./../../assets/styles/_loadingSpin.module.scss";

export const LoadingSpin = ({
  width = '50px',
  height = '50px',
}) => {
  return (
    <div className={styles.loadingSpinContainer}>
      <div className={styles.spinner} style={{ width, height }}></div>
    </div>
  );
};
